import React from 'react';
import SharedVideoDetail from './SharedVideoDetail';
import EmbedPlayer from './EmbedPlayer';
import SharingSns from './SharingSns';

import { Route, Switch } from 'react-router-dom';

function App() {

  return (
    <div className="App">
       <Switch>
        <Route path={'/'}
        exact={true}
        component={SharedVideoDetail}/>
        <Route path={'/test'}
        exact={true}
        component={EmbedPlayer}/>
        <Route path={'/embed/:id'}
        exact={true}
        component={EmbedPlayer}/>
      </Switch>
    </div>
  );
}

export default App;
